import React, { useEffect } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import Spinner from '../../Components/Progress/Spinner'

function AuthLinks() {
  const navigate = useNavigate()
  const { type } = useParams()

  const redirect = (path = '/login', state) => {
    if (state) {
      navigate(path, state)
    } else {
      navigate(path)
    }
  }

  const cta = () => {
    switch (type) {
      case 'login':
        redirect('/auth/login')
        break
      case 'register':
        redirect('/auth/register')
        break
      case 'reset_password':
        redirect('/dashboard', { changePassword: true })
        break
      default:
        redirect('/dashboard')
        break
    }
  }

  useEffect(() => {
    if (!type) redirect()
    else cta()
  }, [])

  return <Spinner />
}

export default AuthLinks
